import { getToken } from 'data/auth/utils'
import { parseApiEntityData } from 'entities-next/common'
import { EntityId } from 'scenes/Dashboard/data/common/types'
import { createApiHandler, CreateApiHandlerConfig } from 'services-next/api'
import { getUrlWithPathParams } from 'services/api'

import { APIInvestment, Investment } from './fundingRound.types'

const INVESTMENTS_ENDPOINT_PATH = 'admin/funding-rounds/investments'

export function getApiInvestmentHandlers(customToken?: string, config: Omit<CreateApiHandlerConfig, 'baseUrl'> = {}) {
  const token = customToken || getToken() || undefined
  const { callApi } = createApiHandler(token, config)

  async function apiCreateInvestment(newInvestment: Investment): Promise<Investment> {
    const investment = await callApi<APIInvestment>({
      method: 'post',
      url: INVESTMENTS_ENDPOINT_PATH,
      data: newInvestment,
    })
    return parseApiInvestment(investment)
  }

  async function apiUpdateInvestment(investmentId: EntityId, investmentData: Investment): Promise<Investment> {
    const investment = await callApi<APIInvestment>({
      method: 'patch',
      url: getUrlWithPathParams(INVESTMENTS_ENDPOINT_PATH, investmentId),
      data: investmentData,
    })
    return parseApiInvestment(investment)
  }

  function apiDeleteInvestment(investmentId: Investment['id']): Promise<void> {
    return callApi<void>({
      method: 'delete',
      url: getUrlWithPathParams(INVESTMENTS_ENDPOINT_PATH, investmentId),
    })
  }

  return {
    apiCreateInvestment,
    apiDeleteInvestment,
    apiUpdateInvestment,
  }
}

export function parseApiInvestment(investment: APIInvestment): Investment {
  return parseApiEntityData(investment)
}
